export function extractCypressLocatorDataCyAttribute(props) {
    return {
        "data-cy": props["data-cy"],
    };
}
//# sourceMappingURL=extractCypressLocatorDataCyAttribute.js.map